import type { Components, Theme } from "@mui/material/styles";

import { ADORNMENT_ALLOWANCE } from "../../variables";

import { INPUT_PADDING_SPACING } from "./input-base";
import { DROP_DOWN_SPACING } from "./select";

const INPUT_LABEL_TRANSFORM = {
  translateX: "--InputLabel-translate-x",
  translateY: "--InputLabel-translate-y",
  scale: "--InputLabel-scale",
} as const;

export const MuiInputLabel: Components<Theme>["MuiInputLabel"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [INPUT_LABEL_TRANSFORM.translateX]: `calc(${theme.spacing(INPUT_PADDING_SPACING)} + var(${ADORNMENT_ALLOWANCE.start}))`,
      [INPUT_LABEL_TRANSFORM.translateY]: theme.spacing(1.25),
      [INPUT_LABEL_TRANSFORM.scale]: 1,

      [ADORNMENT_ALLOWANCE.start]: "0px",
      "&:has(~ .MuiInputBase-adornedStart), &:has(~ .MuiInputBase-root .MuiInputAdornment-positionStart)":
        {
          [ADORNMENT_ALLOWANCE.start]: theme.spacing(4),
        },

      [ADORNMENT_ALLOWANCE.end]: "0px",
      "&:has(~ .MuiInputBase-adornedEnd), &:has(~ .MuiInputBase-root .MuiInputAdornment-positionEnd)":
        {
          [ADORNMENT_ALLOWANCE.end]: theme.spacing(4),
        },

      // 12px padding on each side
      maxWidth: `calc(100% - ${theme.spacing(2 * INPUT_PADDING_SPACING)} - var(${ADORNMENT_ALLOWANCE.start}) - var(${ADORNMENT_ALLOWANCE.end}))`,
      overflowX: "hidden",
      // display descenders
      overflowY: "visible",
      transform: `translate(var(${INPUT_LABEL_TRANSFORM.translateX}), var(${INPUT_LABEL_TRANSFORM.translateY})) scale(var(${INPUT_LABEL_TRANSFORM.scale}))`,

      // leave space for arrow icon
      "&:has(+ .MuiSelect-root)": {
        maxWidth: `calc(100% - ${theme.spacing(2 * INPUT_PADDING_SPACING)} - var(${ADORNMENT_ALLOWANCE.start}) - var(${ADORNMENT_ALLOWANCE.end}) - ${theme.spacing(DROP_DOWN_SPACING)})`,
      },

      "&.Mui-focused, &.MuiInputLabel-shrink": {
        [INPUT_LABEL_TRANSFORM.translateX]: theme.spacing(
          INPUT_PADDING_SPACING
        ),
        [INPUT_LABEL_TRANSFORM.translateY]: theme.spacing(-0.75),
        [INPUT_LABEL_TRANSFORM.scale]: 0.75,

        // preserve padding (ignoring adornments), then unscale
        maxWidth: `calc((100% - ${theme.spacing(2 * INPUT_PADDING_SPACING)}) / var(${INPUT_LABEL_TRANSFORM.scale}))`,
      },
    }),

    sizeSmall: ({ theme }) => ({
      [INPUT_LABEL_TRANSFORM.translateY]: theme.spacing(0.75),
    }),
  },
};
